{
    "SymbolLabel": "Symbol:",
    "SymbolNote": "(Automatically Applies Changes To Fields Bellow)",
    "PatternLabel": "Pattern:",
    "GroupingseparatorLabel": "Grouping Separator:",
    "GroupingseparatorOptionCommaDesc": "(Comma)",
    "GroupingseparatorOptionSpaceDesc": "(Space)",
    "GroupingseparatorOptionFullstopDesc": "(Full-Stop)",
    "DecimalseparatorLabel": "Decimal Separator:",
    "DecimalseparatorOptionFullstopDesc": "(Full-Stop)",
    "DecimalseparatorOptionColonDesc": "(Colon)",
    "DecimalseparatorOptionCommaDesc": "(Comma)",
    "PreviewLabel": "Preview",
    "NAME": "CurrencyDisplayFormat",
    "CurrencyDisplayFormat_SectionHeader": "Currency Display Format"
}